/* eslint-disable no-undef */
import axios from 'axios';
import * as uuid from 'uuid';
import moment from 'moment';
import { Button, Flex, Paragraph } from 'theme-ui';
import Divider from '../divider';
import { clientTypeOptions, frequencyOptions } from './manage-workflow';
import theme from '../../theme';

const frequencyMapper = (key) => {
    if (key === '') {
        return <Paragraph sx={{ mb: '5px' }}></Paragraph>;
    }

    if (key === 'on_creation') {
        return <Paragraph sx={{ mb: '5px' }}>On client creation</Paragraph>;
    }

    if (key === 'on_ch_filing_date') {
        return <Paragraph sx={{ mb: '5px' }}>On CH filing date</Paragraph>;
    }

    if (key === 'on_hmrc_filing_date') {
        return <Paragraph sx={{ mb: '5px' }}>On HMRC filing date</Paragraph>;
    }

    if (key === 'on_specific_date') {
        return <Paragraph sx={{ mb: '5px' }}>On specific date</Paragraph>;
    }

    return (
        <Paragraph sx={{ mb: '5px' }}>
            {moment.utc(`${key}/01/2000`, 'DD/MM/YYYY').format('Do')} day of the month
        </Paragraph>
    );
};

const deleteWorkflowTask = (id, state, updateState) => async () => {
    try {
        updateState({ ...state, loading: true, error: null });

        await axios({
            url: `${process.env.REACT_APP_AQRU_AI_API}/organisations/workflow-tasks/${id}`,
            method: 'DELETE',
        });

        const {
            data: { tasks, total: workflowTasksTotal },
        } = await axios({
            url: `${process.env.REACT_APP_AQRU_AI_API}/organisations/workflow-tasks`,
        });

        updateState({ ...state, loading: false, error: null, tasks, workflowTasksTotal });
    } catch (e) {
        console.log(e);
        updateState({
            ...state,
            loading: false,
            error: 'Uh oh, there has been an error deleting this workflow task',
        });
    }
};

const WorkflowTasks = ({ organisation, state, updateState }) => {
    return (
        <Flex sx={{ flexDirection: 'column', mt: 20 }}>
            <Paragraph sx={{ fontSize: 20, fontWeight: 600 }}>Workflow</Paragraph>
            <Divider width="1200px" />
            <Paragraph sx={{ mb: 20 }}>
                Define tasks to be auto-generated for each service offered to the clients
            </Paragraph>

            {organisation && (
                <Flex sx={{ mb: 50, flexDirection: 'column', width: 1000 }}>
                    <Flex sx={{ justifyContent: 'space-between', mb: 0 }}>
                        <Paragraph
                            sx={{
                                width: 200,
                                fontSize: 17,
                                fontWeight: '600',
                                mt: 10,
                                color: 'text',
                            }}
                        >
                            Tasks
                        </Paragraph>
                        {organisation?.user?.role === 'admin' && (
                            <Button
                                sx={{
                                    border: '1px solid #ccc',
                                    backgroundColor: 'white',
                                    fontSize: 14,
                                    height: 40,
                                    color: 'text',
                                }}
                                onClick={() =>
                                    updateState({
                                        ...state,
                                        workflowView: 'manage',
                                        workflowTask: { title: '', description: '', subtasks: [] },
                                    })
                                }
                            >
                                <i
                                    style={{
                                        marginTop: '0px',
                                        fontSize: '14px',
                                        marginRight: '7px',
                                        cursor: 'pointer',
                                    }}
                                    className="fas fa-plus-circle"
                                />
                                Add new task
                            </Button>
                        )}
                    </Flex>
                    <Divider />
                    <table
                        style={{
                            borderCollapse: 'collapse',
                            width: 'auto',
                            marginTop: 10,
                        }}
                    >
                        <thead
                            style={{
                                backgroundColor: theme.colors.primary,
                                opacity: 0.9,
                                height: 50,
                                color: 'white',
                            }}
                        >
                            <tr style={{ borderTop: '0px solid lightGrey' }}>
                                <th style={{ width: 150, textAlign: 'left', paddingLeft: 20 }}>Task title</th>
                                <th style={{ width: 150, textAlign: 'left', paddingLeft: 20 }}>Service</th>
                                <th style={{ width: 150, textAlign: 'left', paddingLeft: 20 }}>Creation frequency</th>
                                <th style={{ width: 130, textAlign: 'left', paddingLeft: 20 }}></th>
                            </tr>
                        </thead>
                        <tbody
                            style={{
                                borderCollapse: 'collapse',
                                width: 1000,
                            }}
                        >
                            {state.tasks?.map((x, idx) => (
                                <tr key={`workflow_row_${idx}`}>
                                    <td
                                        style={{
                                            padding: 20,
                                            wordWrap: 'break-word',
                                            width: 300,
                                        }}
                                    >
                                        <Paragraph>{x.definition.title}</Paragraph>
                                    </td>
                                    <td
                                        style={{
                                            padding: 20,
                                            wordWrap: 'break-word',
                                            width: 200,
                                        }}
                                    >
                                        <Paragraph>
                                            {organisation?.workflow_definition?.services?.[x.service]?.label}
                                        </Paragraph>
                                    </td>
                                    <td style={{ padding: 20, width: 220 }}>
                                        <Flex sx={{ flexDirection: 'column' }}>
                                            {x.definition.frequency?.map((x) => frequencyMapper(x))}
                                        </Flex>
                                    </td>
                                    <td style={{ padding: 20, justifyContent: 'center' }}>
                                        {organisation?.user?.role === 'admin' && (
                                            <>
                                                <Button
                                                    onClick={() => {
                                                        updateState({
                                                            ...state,
                                                            workflowView: 'manage',
                                                            workflowTask: {
                                                                ...x,
                                                                ...x?.definition,
                                                                newFrequencySelection: frequencyOptions?.filter((y) =>
                                                                    x?.definition?.frequency?.find(
                                                                        (freq) => freq === y.value
                                                                    )
                                                                ),
                                                                clientTypeSelection: clientTypeOptions?.find(
                                                                    (y) => x?.definition?.client_type === y.value
                                                                ),
                                                                subtasks: (x.definition?.subtasks || [])?.map((y) => ({
                                                                    ...y,
                                                                    uiKey: y.uiKey || uuid.v4(),
                                                                })),
                                                                newWorkflowTaskService: {
                                                                    value: x.service,
                                                                    label: organisation?.workflow_definition
                                                                        ?.services?.[x.service]?.label,
                                                                },
                                                            },
                                                        });
                                                        window.scrollTo({ top: 0, behavior: 'smooth' });
                                                    }}
                                                    variant="light"
                                                    sx={{ height: 40, width: 100 }}
                                                >
                                                    <i
                                                        style={{
                                                            marginRight: '7px',
                                                            fontSize: '12px',
                                                            cursor: 'pointer',
                                                        }}
                                                        className="fas fa-pencil"
                                                        aria-hidden="true"
                                                    />
                                                    Edit
                                                </Button>
                                                <Button
                                                    onClick={async () => {
                                                        updateState({
                                                            ...state,
                                                            showDeleteWorkflowTaskConfirmation: true,
                                                            confirmCallback: deleteWorkflowTask(
                                                                x.id,
                                                                state,
                                                                updateState
                                                            ),
                                                        });
                                                    }}
                                                    variant="light"
                                                    sx={{ mt: 10, height: 40, width: 100 }}
                                                >
                                                    <i
                                                        style={{
                                                            marginRight: '7px',
                                                            fontSize: '12px',
                                                            cursor: 'pointer',
                                                            color: 'red',
                                                        }}
                                                        className="fas fa-trash"
                                                        aria-hidden="true"
                                                    />
                                                    Delete
                                                </Button>
                                            </>
                                        )}
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </Flex>
            )}
        </Flex>
    );
};

export default WorkflowTasks;
